export const TWENTY_FOUR = 24;
export const LENGTH_OF_STAY_TIME_IN_HOURS = 'H';
export const LENGTH_OF_STAY_TIME_IN_DAYS = 'D';

export const DEFAULT_TIME_FORMAT = 'MM/DD/YYYY HH:mm';
export const GMT_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
